/** Whole USD, no cents — used across parachute workflow UI. */
export const fmt = (v: unknown) =>
  v == null || isNaN(v as number)
    ? '$0'
    : new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(
        Number(v)
      );

/** Format numeric string with thousands commas (e.g. "1234567" → "1,234,567") for display; raw when empty. */
export const formatWithCommas = (s: unknown) => {
  if (s == null || s === '') return '';
  const cleaned = String(s).replace(/[^0-9.]/g, '');
  if (!cleaned) return '';
  const parts = cleaned.split('.');
  const intPart = parts[0] || '0';
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.length > 1 ? `${withCommas}.${parts[1]}` : withCommas;
};

/** Strip to digits and at most one decimal point for storing raw currency input. */
export const cleanCurrencyInput = (val: unknown) => {
  const v = String(val ?? '').replace(/[^0-9.]/g, '');
  const idx = v.indexOf('.');
  if (idx === -1) return v;
  return v.slice(0, idx + 1) + v.slice(idx + 1).replace(/\./g, '');
};
